import { change } from 'redux-form';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { all, call, put, spawn } from 'redux-saga/effects';
import { defineMessages } from 'react-intl';
import { planById } from 'redux/saga/entities/bound';
import { msaIdToAlias } from 'constants/msas';
import { createUserAndLogIn } from 'features/Login/Authentication.saga';
import { signup } from 'features/Signup/FormAction';
import { ga } from 'helpers/multitrack';
import { segment } from 'helpers/segment';
import { trackGoogleTagManagerEvent } from 'components/GoogleTagManager/GoogleTagManager';
import { addCartItem, emptyCart } from 'redux/modules/cart';
import { BaseProduct } from './BaseProduct';

export const messages = defineMessages({
  monthlySubscription: {
    id: 'signup.planProduct.monthlySubscription',
    defaultMessage: 'Monthly subscription',
  },
});

export class PlanProduct extends BaseProduct {
  static key = 'PlanProduct';

  static *loadSignupData(client) {
    const { planId } = yield call(PlanProduct.getProductData);
    const plan = yield call(fetchEntityIfNeeded, planById, [client, planId]);
    yield call(segment.track, 'Membership Purchase', {
      msaId: plan.msa_id,
      msaName: msaIdToAlias(plan.msa_id),
      gtm: true,
    });
    yield spawn(trackGoogleTagManagerEvent, {
      msaId: plan.msa_id,
      msaName: msaIdToAlias(plan.msa_id),
    });

    yield put(change('signup', 'planId', planId));
  }

  static *submitSignupData(client, basePayload) {
    const { planId } = yield call(PlanProduct.getProductData);
    return yield call(createUserAndLogIn, client, signup, {
      ...basePayload,
      plan_id: planId,
    });
  }

  static *loadPurchaseData(client) {
    const { planId } = yield call(PlanProduct.getProductData);
    const plan = yield call(fetchEntityIfNeeded, planById, [client, planId]);

    yield all([
      put(change('purchase', 'planId', plan.id)),
      put(change('purchase', 'msaId', plan.msa_id)),
      put(emptyCart()),
      put(
        addCartItem('plan', messages.monthlySubscription, plan.price, {
          planCode: plan.plan_code,
          isTaxable: true,
        })
      ),
    ]);
  }

  static *trackPurchaseFailure() {
    const { planId } = yield call(PlanProduct.getProductData);
    yield call(segment.track, 'Membership Purchase Errors', {
      category: 'Membership Purchase',
      label: `plan-${planId}`,
    });
    yield spawn(ga, 'Membership Purchase', 'Membership Purchase Errors', `plan-${planId}`);
  }

  static *trackPurchaseSuccess(result) {
    yield call(BaseProduct.trackPurchaseSuccess, result);
  }

  static *trackSignupFailure() {
    const { planId } = yield call(PlanProduct.getProductData);
    yield call(segment.track, 'Create Account Error', {
      category: 'Membership Purchase',
      label: `plan-${planId}`,
    });
    yield spawn(ga, 'Membership Purchase', 'Create Account Error', `plan-${planId}`);
  }

  static *trackSignupSuccess() {
    const { planId } = yield call(PlanProduct.getProductData);
    yield call(segment.track, 'Create Account Success', {
      category: 'Membership Purchase',
      label: `plan-${planId}`,
    });
    yield spawn(ga, 'Membership Purchase', 'Create Account Success', `plan-${planId}`);
  }
}
